<!-- 停止检验通知单 sqm -->
<template>
  <table_component :kindType="data.kindType" :getData="data.getData" v-if="data.getInfoFlag"
    :subLoading="data.subLoading">
    <template #auditContent>
      <form-area :title="[h_i18n('0addf9d81daedc6979addd92d00e46c1')+h_i18n('59c1d28ffbf075894cb2684f702476c5'),h_i18n('0addf9d81daedc6979addd92d00e46c1')+h_i18n('bc50786c52f189359fcbd4b193c1a3aa')]" title-height="80px">
        <template #default="{value}">
          <!-- 停检单闭环审核 -->
          <form-body  v-if="value === h_i18n('0addf9d81daedc6979addd92d00e46c1')+h_i18n('bc50786c52f189359fcbd4b193c1a3aa')">
            <tr>
              <!-- 审核结论 -->
              <report-td :title="h_i18n('8c4ab5982fcea30b260715ac494e7922')" colspan="4:8">
                <el-tag v-if="data.getData.auditStatus === 3409" type="warning" size="small">{{data.getData.auditStatusName}}</el-tag>
                <el-tag v-else-if="data.getData.auditStatus === 3410" type="danger" size="small">{{data.getData.auditStatusName}}</el-tag>
                <el-tag v-else-if="data.getData.auditStatus" size="small">{{data.getData.auditStatusName}}</el-tag>
                <el-tag v-else>-</el-tag>
              </report-td>
              <!-- 闭环说明 -->
              <report-td :title="h_i18n('ff59f0a06da5aecb0d3b8ba32ef2544f')" colspan="4:8">
                {{ data.getData.closeMark || '-'}}
              </report-td>
            </tr>
          </form-body>
          <!-- 停检单整改 -->
          <form-body  v-if="value === h_i18n('0addf9d81daedc6979addd92d00e46c1')+h_i18n('59c1d28ffbf075894cb2684f702476c5')">
            <tr>
              <!-- 整改说明 -->
              <report-td :title="h_i18n('E78DD692818C3A8B4D097496A2A73419')" colspan="4:8">
                {{ data.getData.rectifyMark || '-'}}
              </report-td>
              <!-- 见证资料 -->
              <report-td :title="h_i18n('89ddc81fb9e324adc0948a4ce826b47a')" colspan="4:8">
                <!-- <h-file v-if="data.getData.closeFileUuid" :name="data.getData.closeFile"
                  :url="data.getData.closeFileUuid" :delete-type="false">
                </h-file> -->
                <span v-if="data.getData.closeFileUuid" class="blueClick"
                  @click="download(data.getData.closeFileUuid,data.getData.closeFile)">{{ data.getData.closeFile }}</span>
                <span v-else>-</span>
              </report-td>
            </tr>
            <tr>
              <!-- 整改人 -->
              <report-td :title="h_i18n('14e6d80d29ff92a7f9be99a5e7f4eaf2')" colspan="4:8">{{ data.getData.rectifyMan || '-'}}</report-td>
              <!-- 整改时间 -->
              <report-td :title="h_i18n('ecbd3df43afb03834741469f71ea5d02')" colspan="4:8">{{ time(data.getData.rectifyDate , 6) || '-' }}</report-td>
            </tr>
          </form-body>
        </template>
      </form-area>
    </template>
    <template #btn>
      <inspection-footer class="table_footer_style">
        <template #footer>
          <h-button-group align="center">
            <h-button @click="routerBack" type="primary" size="small">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
          </h-button-group>
        </template>
      </inspection-footer>
    </template>
  </table_component>
    
  </template>
  


<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
  import table_component from "../tableComponent/index.vue"
  const { proxy, ctx } = getCurrentInstance()
  const route = useRoute()

  const data = reactive({
    kindType:'detail',
    subLoading:false,
    getInfoFlag:false,
    getData:{},
  })

  const routerBack = () => {
    proxy.$router.back()
  }

  const getInfo = () => {
    proxy.startLoading(h_i18n('8f64f3e8f07e9b00a0eca21f01a208c6'))
    proxy.$http({
      url:'/base/rejectsStop/rejectsStopDetail',
      method:'get',
      params:{
        stopCheckId:data.stopCheckId
      }
    }).then(res=>{
      if(res.data.data){
        data.getData = res.data.data
        data.getData.dataFrom = route.query.dataFrom
        data.getData.stopCheckId = data.stopCheckId
        if(!data.sourceId){
          data.sourceId = data.getData.sourceId
        }
        if(!data.questionTypeName){
          data.questionTypeName = data.getData.questionTypeName
        }
        // 兼容附件 badPictureUuid
        if(data.getData.badPictureUuid){
          if(data.getData.badPictureUuid.includes('http')){

          }else{
            // data.getData.badPictureUuid = 'https://sqm.haier.net/downLoadFile?appName=hmqm&fileUUID='+data.getData.badPictureUuid
            data.getData.badPictureUuid = '/base/fileDownload/downloadFile?filePath='+data.getData.badPictureUuid
          }
        }
        data.getInfoFlag = true
        // 不良列表
        if(data.sourceId){
          getOtherInfo()
        }else if(data.getData.sourceId){
          getOtherInfo()
        }
      }
    }).catch(err=>{

    }).finally(()=>{
      proxy.closeLoading()
    })
  }

  const getOtherInfo = () => {
    if(data.questionTypeName && data.questionTypeName === '维修备件ppm超底线'){
      proxy.$http({
        url:'/base/hdyReport/getByZjId?zjId='+data.sourceId || data.getData.sourceId,
        method:'get',
      }).then(res=>{
        if(res.data.data){
          data.getData.rectifyListData = [res.data.data]
        }
      }).catch(err=>{

      })
    }else{
    proxy.$http({
      url:'/base/rejectsRectify/selectRejectsBLCL',
      method:'get',
      params:{
        id:data.sourceId || data.getData.sourceId,
        type:data.questionTypeName || data.getData.questionTypeName
      }
    }).then(res=>{
      if(res.data.data){
        data.getData.rectifyListData = res.data.data
      }
    }).catch(err=>{

    })
    }
  }
  // 下载
  const download = (uid,name) => {
    proxy.startLoading()
    return proxy.$http({
      method: 'get',
      url: '/base/fileDownload/downloadFile?filePath=' + uid,
      responseType: "blob",
    }).then(async res => {
      if (res.status === 200) {
        let blob = new Blob([res.data]); // 文件流
        let blobUrl = URL.createObjectURL(blob);
        const link = document.createElement("a"); //模拟a链接，不支持低版本ie
        link.download = name;
        link.style.display = "none";
        link.href = blobUrl;
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
      } else {
        proxy.error(h_i18n('15efc64c8e8760bc029f83ee59efa351'))
      }
    }).finally(()=>{
      proxy.closeLoading()
    })
  }
  onBeforeMount(()=>{
    if (route.query) {
      data.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      data.supplyName = route.query.supplyName || ''
      data.trueName = route.query.trueName || undefined
      data.kindType = route.query.kindType ? route.query.kindType : 'detail'
      data.stopCheckId = route.query.stopCheckId ?  route.query.stopCheckId : undefined
      data.sourceId = route.query.sourceId ?  route.query.sourceId : undefined
    }
  })
  onMounted(() => {
    if(route.query.dataFrom != 'sqm'){
      proxy.$router.replace('/404')
      return
    }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => {
          proxy.$router.back()
        },})
      return
    }
    data.stopCheckId ? getInfo() : proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('e12a3630be263185d2e5c4418427aae4'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
    callback: (action) => {
      proxy.$router.back()
    },})
    for(let i = 1 ; i < 10; i++){
      setTimeout(() => {
        proxy.postThisPageHeightMore()
      }, i*100);
    }
  })

  </script>

<style lang="scss">
  .table_footer_style{
    // margin-top: -10px !important;
    .haier-table{
      border-top: 0 !important;
    }
  }
  .haier-file-text:hover {
    white-space: normal !important;
    overflow: none;
    text-overflow: none;
    line-height: 20px;
    height: 100%;
  }
  .blueClick {
    color: #165dff;
    text-decoration: none;
    outline: none;
    cursor: pointer;
    transition: color 0.3s;
    &:hover {
      color: #4080ff;
    }
    &:active {
      color: #0e42d2;
    }
  }
</style>